/* eslint-disable simple-import-sort/imports */
import { Navigate, useRoutes } from 'react-router-dom'

import AuthLayout from '@/layouts/auth'
import DashboardLayout from '@/layouts/default'
import Overview from '@/pages/dashboard/overview'
import Favorites from '@/pages/dashboard/favorites'
import SearchResults from '@/pages/search-results'
import Folder from '@/pages/folder'
import { ProtectedRoute, BillingGuard } from '@qse/config'

import {
  LoginScreen,
  CompleteRegistrationPage,
  ConfirmEmailPage,
  NewPasswordScreen,
  ForgotPasswordScreen,
  ResetPasswordScreen,
  TwoFAVerifyScreen,
  VerificationScreen,
  Setup2FAScreen,
  ProfileScreen,
  CheckInvitation,
} from '@qse/auth-ui'
import { storage } from '@qse/utils'
import Trash from '@/pages/dashboard/trash'
import GenerateEntropyScreen from '@/pages/dashboard/generate-entropy'
import GenerateKeysScreen from '@/pages/dashboard/generate-keys'
import Reseller from '@/pages/management/reseller'
import AccountDeletionPage from '@/pages/account-deletion'
import { AppRoutesList } from './routes'

function AppRoutes() {
  const routes = useRoutes([
    {
      path: '/',
      element: <Navigate replace to={AppRoutesList.login} />,
    },
    {
      element: (
        <ProtectedRoute type="public">
          <AuthLayout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: AppRoutesList.login,
          element: <LoginScreen isDashboard={true} />,
        },
        {
          path: AppRoutesList.completeRegistration,
          element: <CompleteRegistrationPage />,
        },
        {
          path: AppRoutesList.confirmEmail,
          element: <ConfirmEmailPage />,
        },
        {
          path: AppRoutesList.newPassword,
          element: <NewPasswordScreen />,
        },
        {
          path: AppRoutesList.forgotPassword,
          element: <ForgotPasswordScreen />,
        },
        {
          path: AppRoutesList.resetPassword,
          element: <ResetPasswordScreen />,
        },
        {
          path: AppRoutesList.verification,
          element: <VerificationScreen />,
        },
        {
          path: AppRoutesList.twoFA,
          element: (
            <Setup2FAScreen
              onSuccess={user => {
                console.log({ user })
                // The user will be automatically redirected to dashboard by the auth flow
              }}
              onTOTPSetupRequired={totpSetup => {
                storage.localStorage.setItem('totp_setup_data', JSON.stringify(totpSetup))
              }}
            />
          ),
        },
        {
          path: AppRoutesList.twoFAVerify,
          element: (
            <TwoFAVerifyScreen
              onSuccess={user => {
                console.log({ user })
                // The user will be automatically redirected to dashboard by the auth flow
              }}
              onTOTPCodeRequired={() => {
                console.log('TOTP code required')
              }}
            />
          ),
        },
      ],
    },
    {
      path: AppRoutesList.checkInvitation,
      element: <CheckInvitation />,
    },
    {
      path: AppRoutesList.accountDeletion,
      element: <AccountDeletionPage />,
    },
    {
      element: (
        <ProtectedRoute type="protected">
          <BillingGuard>
            <DashboardLayout />
          </BillingGuard>
        </ProtectedRoute>
      ),
      children: [
        {
          path: AppRoutesList.dashboard,
          element: <Overview />,
        },
        {
          path: AppRoutesList.favorites,
          element: <Favorites />,
        },
        {
          path: AppRoutesList.searchResults,
          element: <SearchResults />,
        },
        {
          path: AppRoutesList.trash,
          element: <Trash />,
        },
        {
          path: AppRoutesList.folder,
          element: <Folder />,
        },
        {
          path: AppRoutesList.profile,
          element: <ProfileScreen />,
        },
        {
          path: AppRoutesList.generateEntropy,
          element: <GenerateEntropyScreen />,
        },
        {
          path: AppRoutesList.generateKeys,
          element: <GenerateKeysScreen />,
        },
        {
          path: AppRoutesList.reseller,
          element: <Reseller />,
        },
        {
          path: '*',
          element: (
            <Navigate replace state={{ showNotFoundError: true }} to={AppRoutesList.dashboard} />
          ), // Redirect to My Drive with error notification
        },
      ],
    },
  ])

  return routes
}

export default AppRoutes
